var _marker, _marker2, _marker3, _marker4, _rect, _rect2, _text, _text2, _line, _rect3, _text3, _text4, _text5, _text6, _line2, _rect4, _text7, _text8, _rect5, _text9, _text0, _rect6, _text1, _text10, _text11, _line3, _line4, _line5, _rect7, _text12, _line6, _text13, _text14, _line7, _text15, _rect8, _text16, _line8, _circle, _text17, _circle2, _text18, _circle3, _text19, _circle4, _text20, _circle5, _text21, _circle6, _text22, _circle7, _text23, _line9, _text24, _line0, _text25, _rect9, _text26, _text27, _line1, _text28, _rect0, _text29, _text30, _line10, _text31, _text32, _rect1, _text33, _line11, _text34, _text35, _text36, _path, _text37, _rect10, _text38, _line12, _text39, _text40, _path2, _text41, _line13, _text42, _line14, _text43, _line15, _text44, _line16, _text45, _circle8, _text46, _circle9, _text47;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEtlLeadsPipeline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 560,
    viewBox: "0 0 900 560",
    xmlns: "http://www.w3.org/2000/svg",
    fontFamily: "Inter, system-ui, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _marker || (_marker = /*#__PURE__*/React.createElement("marker", {
    id: "ab",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#06B6D4"
  }))), _marker2 || (_marker2 = /*#__PURE__*/React.createElement("marker", {
    id: "aa",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#F59E0B"
  }))), _marker3 || (_marker3 = /*#__PURE__*/React.createElement("marker", {
    id: "av",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#a78bfa"
  }))), _marker4 || (_marker4 = /*#__PURE__*/React.createElement("marker", {
    id: "ao",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#f97316"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0c1628"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#060c14"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 560,
    fill: "url(#bgGrad)",
    rx: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 560,
    fill: "none",
    rx: 12,
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 36,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: -0.3
  }, "Azure ETL Lead Deduplication &amp; Distribution Pipeline")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 54,
    textAnchor: "middle",
    fill: "#7dd3fc",
    fontSize: 10
  }, "Banking Client \xB7 Azure Blob Storage \xB7 Azure Data Factory \xB7 Databricks \xB7 Azure SQL DB \xB7 Power BI")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 68,
    x2: 860,
    y2: 68,
    stroke: "rgba(255,255,255,0.07)",
    strokeWidth: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 78,
    width: 552,
    height: 44,
    rx: 6,
    fill: "rgba(139,92,246,0.07)",
    stroke: "#8b5cf6",
    strokeWidth: 1.5,
    strokeDasharray: "5,3"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 97,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 12,
    fontWeight: 700
  }, "Azure Data Factory")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 112,
    textAnchor: "middle",
    fill: "#7c6fad",
    fontSize: 9
  }, "Orchestrates &amp; schedules the full pipeline \xB7 trigger on new SFTP files")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 610,
    y: 97,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 11,
    fontWeight: 600
  }, "Pipeline Orchestrator")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 610,
    y: 112,
    textAnchor: "middle",
    fill: "#7c6fad",
    fontSize: 9
  }, "monitors \xB7 retries \xB7 logs")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 473,
    y1: 122,
    x2: 473,
    y2: 138,
    stroke: "#8b5cf6",
    strokeWidth: 1.5,
    strokeDasharray: "3,2",
    markerEnd: "url(#av)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 138,
    width: 112,
    height: 52,
    rx: 6,
    fill: "#0a1628",
    stroke: "#06B6D4",
    strokeWidth: 1.5
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 159,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontSize: 11,
    fontWeight: 600
  }, "Call Center 1")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 176,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 9
  }, "lead_cc1.csv \xB7 SFTP")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 218,
    width: 112,
    height: 52,
    rx: 6,
    fill: "#0a1628",
    stroke: "#06B6D4",
    strokeWidth: 1.5
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 239,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontSize: 11,
    fontWeight: 600
  }, "Call Center 2")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 256,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 9
  }, "lead_cc2.csv \xB7 SFTP")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 298,
    width: 112,
    height: 52,
    rx: 6,
    fill: "#0a1628",
    stroke: "#06B6D4",
    strokeWidth: 1.5
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 319,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontSize: 11,
    fontWeight: 600
  }, "Call Center 3")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 336,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 9
  }, "lead_cc3.csv \xB7 SFTP")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 74,
    y: 374,
    textAnchor: "middle",
    fill: "#334155",
    fontSize: 9,
    fontStyle: "italic"
  }, "+ more CCs")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 164,
    x2: 196,
    y2: 218,
    stroke: "#06B6D4",
    strokeWidth: 1.5,
    markerEnd: "url(#ab)"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 244,
    x2: 196,
    y2: 244,
    stroke: "#06B6D4",
    strokeWidth: 1.5,
    markerEnd: "url(#ab)"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 324,
    x2: 196,
    y2: 270,
    stroke: "#06B6D4",
    strokeWidth: 1.5,
    markerEnd: "url(#ab)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 203,
    width: 144,
    height: 82,
    rx: 6,
    fill: "#0a1628",
    stroke: "#7dd3fc",
    strokeWidth: 1.5
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 228,
    textAnchor: "middle",
    fill: "#7dd3fc",
    fontSize: 12,
    fontWeight: 700
  }, "Azure Blob Storage")), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 211,
    y1: 235,
    x2: 329,
    y2: 235,
    stroke: "rgba(125,211,252,0.1)",
    strokeWidth: 1
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 251,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 9
  }, "SFTP \xB7 per-CC containers")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 266,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 9
  }, "raw CSV / Excel files")), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 342,
    y1: 244,
    x2: 385,
    y2: 244,
    stroke: "#06B6D4",
    strokeWidth: 1.5,
    markerEnd: "url(#ab)"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 363,
    y: 237,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 9
  }, "ingest")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 387,
    y: 138,
    width: 172,
    height: 214,
    rx: 6,
    fill: "#0a1628",
    stroke: "#22c55e",
    strokeWidth: 1.5
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 473,
    y: 163,
    textAnchor: "middle",
    fill: "#22c55e",
    fontSize: 13,
    fontWeight: 700
  }, "ETL Pipeline")), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 171,
    x2: 546,
    y2: 171,
    stroke: "rgba(34,197,94,0.15)",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 403,
    cy: 188,
    r: 3,
    fill: "#22c55e",
    opacity: 0.65
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 414,
    y: 192,
    fill: "#cbd5e1",
    fontSize: 9.5
  }, "Parse &amp; normalise files")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 403,
    cy: 205,
    r: 3,
    fill: "#22c55e",
    opacity: 0.65
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 414,
    y: 209,
    fill: "#cbd5e1",
    fontSize: 9.5
  }, "Standardise columns")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 403,
    cy: 222,
    r: 3,
    fill: "#ef4444",
    opacity: 0.8
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 414,
    y: 226,
    fill: "#fca5a5",
    fontSize: 9.5
  }, "&#x2717; Reject: current clients")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 403,
    cy: 239,
    r: 3,
    fill: "#ef4444",
    opacity: 0.8
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 414,
    y: 243,
    fill: "#fca5a5",
    fontSize: 9.5
  }, "&#x2717; Reject: neg. blacklist")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 403,
    cy: 256,
    r: 3,
    fill: "#F59E0B",
    opacity: 0.8
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 414,
    y: 260,
    fill: "#fcd34d",
    fontSize: 9.5
  }, "&#x2717; Reject: recent DB leads")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 403,
    cy: 273,
    r: 3,
    fill: "#F59E0B",
    opacity: 0.8
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 414,
    y: 277,
    fill: "#fcd34d",
    fontSize: 9.5
  }, "&#x21C4; Round Robin (cross-CC)")), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 403,
    cy: 290,
    r: 3,
    fill: "#22c55e",
    opacity: 0.65
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 414,
    y: 294,
    fill: "#cbd5e1",
    fontSize: 9.5
  }, "&#x2713; Accept &amp; load to SQL DB")), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 304,
    x2: 546,
    y2: 304,
    stroke: "rgba(34,197,94,0.15)",
    strokeWidth: 1
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 473,
    y: 320,
    textAnchor: "middle",
    fill: "#334155",
    fontSize: 9
  }, "Python \xB7 Databricks \xB7 triggered by ADF")), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 559,
    y1: 244,
    x2: 604,
    y2: 244,
    stroke: "#06B6D4",
    strokeWidth: 1.5,
    markerEnd: "url(#ab)"
  })), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 581,
    y: 237,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 9
  }, "load")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 387,
    y: 376,
    width: 172,
    height: 48,
    rx: 6,
    fill: "rgba(249,115,22,0.05)",
    stroke: "#f97316",
    strokeWidth: 1.5,
    strokeDasharray: "4,2"
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 473,
    y: 396,
    textAnchor: "middle",
    fill: "#fb923c",
    fontSize: 11,
    fontWeight: 700
  }, "Bank Reference SFTP")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 473,
    y: 412,
    textAnchor: "middle",
    fill: "#a05a30",
    fontSize: 9
  }, "curr. clients \xB7 neg. blacklist")), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 473,
    y1: 375,
    x2: 473,
    y2: 353,
    stroke: "#f97316",
    strokeWidth: 1.5,
    strokeDasharray: "3,2",
    markerEnd: "url(#ao)"
  })), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 482,
    y: 366,
    fill: "#a05a30",
    fontSize: 8
  }, "ref data")), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 606,
    y: 203,
    width: 144,
    height: 82,
    rx: 6,
    fill: "#0a1628",
    stroke: "#7dd3fc",
    strokeWidth: 1.5
  })), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 678,
    y: 228,
    textAnchor: "middle",
    fill: "#7dd3fc",
    fontSize: 12,
    fontWeight: 700
  }, "Azure SQL DB")), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 678,
    y: 244,
    textAnchor: "middle",
    fill: "#7dd3fc",
    fontSize: 10,
    fontWeight: 600
  }, "Main Database")), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 619,
    y1: 251,
    x2: 737,
    y2: 251,
    stroke: "rgba(125,211,252,0.1)",
    strokeWidth: 1
  })), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 678,
    y: 267,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 9
  }, "Deduplicated leads")), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 678,
    y: 281,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 9
  }, "Confirmed final list")), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 778,
    y: 203,
    width: 104,
    height: 82,
    rx: 6,
    fill: "rgba(6,182,212,0.05)",
    stroke: "rgba(6,182,212,0.18)",
    strokeWidth: 1
  })), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 830,
    y: 228,
    textAnchor: "middle",
    fill: "#06B6D4",
    fontSize: 11,
    fontWeight: 700
  }, "Banking Client")), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 791,
    y1: 235,
    x2: 869,
    y2: 235,
    stroke: "rgba(6,182,212,0.1)",
    strokeWidth: 1
  })), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 830,
    y: 253,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 9
  }, "5,000+ \u20AC / month")), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 830,
    y: 268,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 9
  }, "recurring revenue")), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 830,
    y: 281,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 8
  }, "per-CC lead management")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 692 285 L 692 322 L 782 322 L 782 337",
    fill: "none",
    stroke: "#8b5cf6",
    strokeWidth: 1.5,
    strokeDasharray: "3,2",
    markerEnd: "url(#av)"
  })), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 737,
    y: 318,
    textAnchor: "middle",
    fill: "#6b4fa0",
    fontSize: 8
  }, "sync")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 339,
    width: 144,
    height: 66,
    rx: 6,
    fill: "rgba(139,92,246,0.06)",
    stroke: "#8b5cf6",
    strokeWidth: 1.5
  })), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 782,
    y: 359,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 12,
    fontWeight: 700
  }, "Power BI")), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 723,
    y1: 367,
    x2: 841,
    y2: 367,
    stroke: "rgba(139,92,246,0.12)",
    strokeWidth: 1
  })), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 782,
    y: 382,
    textAnchor: "middle",
    fill: "#7c6fad",
    fontSize: 9
  }, "Lead pipeline dashboard")), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    x: 782,
    y: 397,
    textAnchor: "middle",
    fill: "#7c6fad",
    fontSize: 8
  }, "bank + CC access")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 678 285 L 678 460 L 270 460 L 270 285",
    fill: "none",
    stroke: "#F59E0B",
    strokeWidth: 1.5,
    strokeDasharray: "6,4",
    markerEnd: "url(#aa)"
  })), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 474,
    y: 478,
    textAnchor: "middle",
    fill: "#F59E0B",
    fontSize: 10,
    fontWeight: 500
  }, "Accepted leads written back to each CC's SFTP folder")), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 516,
    x2: 42,
    y2: 516,
    stroke: "#06B6D4",
    strokeWidth: 2
  })), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 520,
    fill: "#475569",
    fontSize: 9
  }, "Forward flow")), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 135,
    y1: 516,
    x2: 155,
    y2: 516,
    stroke: "#F59E0B",
    strokeWidth: 1.5,
    strokeDasharray: "5,3"
  })), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    x: 161,
    y: 520,
    fill: "#475569",
    fontSize: 9
  }, "Return flow")), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 238,
    y1: 516,
    x2: 258,
    y2: 516,
    stroke: "#8b5cf6",
    strokeWidth: 1.5,
    strokeDasharray: "4,2"
  })), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    x: 264,
    y: 520,
    fill: "#475569",
    fontSize: 9
  }, "ADF / PBI sync")), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 358,
    y1: 516,
    x2: 378,
    y2: 516,
    stroke: "#f97316",
    strokeWidth: 1.5,
    strokeDasharray: "4,2"
  })), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    x: 384,
    y: 520,
    fill: "#475569",
    fontSize: 9
  }, "Bank reference data")), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 493,
    cy: 516,
    r: 4,
    fill: "#ef4444",
    opacity: 0.8
  })), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    x: 502,
    y: 520,
    fill: "#475569",
    fontSize: 9
  }, "Hard rejection")), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 582,
    cy: 516,
    r: 4,
    fill: "#F59E0B",
    opacity: 0.8
  })), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    x: 591,
    y: 520,
    fill: "#475569",
    fontSize: 9
  }, "Conditional / assign")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtlLeadsPipeline);
export default __webpack_public_path__ + "static/media/etl-leads-pipeline.737c32491269ac75409557867010a3b0.svg";
export { ForwardRef as ReactComponent };